import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'

export const PhoneIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const fillColour = customColour ? customColour : '#000000'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M3.99,0.38 L5.18,3.6 C5.38,4.2 5.34,4.4 4.82,4.87 C4.29,5.34 3.72,5.7 3.82,6.08 C3.93,6.47 5.82,10.01 8.32,10.92 C9.07,11.19 9.16,11.25 9.62,10.75 C10.09,10.25 10.48,9.73 10.98,9.87 C11.48,10 14.62,11.12 14.62,11.12 C14.62,11.12 15.23,11.5 14.9,12.66 C14.57,13.82 13.05,15.14 11.2,14.98 C9.35,14.82 2.4,11.9 0.15,4.79 C-0.5,2.7 1.15,0.14 2.5,0.03 C3.85,-0.1 3.99,0.38 3.99,0.38"
        data-testid="icon-phone"
        fill={fillColour}
      />
    </Icon>
  )
}
